<template>
    <header class="navbar">
        <div class="container navbar-inner">
            <router-link to="/" @click="closeMenu"><img :src="isOpen ? require('./../assets/images/dark-logo.png') : require('./../assets/images/logo.png')"
                alt="Moin Mation Logo" class="logo" /></router-link>
            <div class="hamburger" v-if="!isOpen" @click="toggleMenu">
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
            </div>

            <!-- Cross icon -->
            <div class="close-icon" v-if="isOpen" @click="toggleMenu">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M2 2L8 8" stroke="#101010" stroke-width="2.5" stroke-linecap="round" />
                    <path d="M22 2L16 8" stroke="#101010" stroke-width="2.5" stroke-linecap="round" />
                    <path d="M2 22L8 16" stroke="#101010" stroke-width="2.5" stroke-linecap="round" />
                    <path d="M22 22L16 16" stroke="#101010" stroke-width="2.5" stroke-linecap="round" />
                </svg>
            </div>

            <nav :class="{ 'mobile-open': isOpen }">
                <router-link to="/" @click="closeMenu">Home</router-link>
                <router-link to="/about" @click="closeMenu">About</router-link>
                <router-link to="/works" @click="closeMenu">Works</router-link>
                <router-link to="/contact" @click="closeMenu">Contact</router-link>
                <button class="talk-btn talk-btn-mobile" @click="goToContact">Lets Talk</button>
            </nav>
            <button class="talk-btn talk-btn-desktop" @click="goToContact">Lets Talk</button>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Navbar',
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
        },
        closeMenu() {
            this.isOpen = false;
        },
        goToContact() {
            this.closeMenu();
            this.$router.push({ path: "/contact" });
        },
    }
};
</script>

<style scoped>
nav a.router-link-exact-active {
    color: #ffffff;
}

.navbar {
    width: 100%;
    padding: 32px 0;
    background: #111;
    position: fixed;
    top: 0;
    z-index: 1000;
}

.navbar-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}

.logo {
    width: 140px;
    transition: opacity 0.3s ease;
}

.mobile-logo {
    display: none;
}

nav {
    display: flex;
    gap: 40px;
}

nav a {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    text-decoration: none;
    transition: opacity 0.3s ease;
}

nav a:hover {
    opacity: 0.7;
}

.talk-btn {
    background: #434343;
    color: #f5f3ef;
    padding: 10px 20px;
    border-radius: 8px;
    border: none;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease;
    text-align: center;
    font-family: 'Sora', sans-serif;
}

.talk-btn:hover {
    background: #555;
}

.talk-btn-desktop {
    display: inline-block;
}

.talk-btn-mobile {
    display: none;
}

.hamburger {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    cursor: pointer;
    z-index: 1100;
    padding-right: 10px;
}

.hamburger-line {
    width: 24px;
    height: 2px;
    background-color: #fff;
    margin: 4px 0;
    border-radius: 1px;
    transition: all 0.3s ease;
}

.hamburger svg {
    width: 24px;
    height: 24px;
}

.hamburger span:nth-child(1) {
    width: 14px;
    align-self: flex-start;
}

.hamburger span:nth-child(2) {
    width: 28px;
    align-self: center;
}

.hamburger span:nth-child(3) {
    width: 14px;
    align-self: flex-end;
}

@media (max-width: 768px) {
    nav {
        position: fixed;
        top: 0;
        left: 0;
        background: #f5f3ef;
        width: 100%;
        height: 100%;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        padding: 0 20px 0;
        gap: 35px;
        display: flex;

        opacity: 0;
        transform: translateX(-100%);
        pointer-events: none;
        transition: transform 0.3s ease-in-out, opacity 0.2s ease-in-out 0.1s;
        z-index: 999;
    }

    nav.mobile-open {
        opacity: 1;
        transform: translateX(0);
        pointer-events: auto;
    }

    .logo {
        width: 121px;
        position: relative;
        z-index: 1101;
    }

    .hamburger {
        display: flex;
        z-index: 1000;
    }

    .hamburger-line {
        transition: all 0.3s ease;
        opacity: 1;
    }

    .hamburger.open .hamburger-line {
        opacity: 0;
        transform: translateY(-5px);
    }

    .hamburger svg {
        width: 24px;
        height: 24px;
        opacity: 0;
        transform: scale(0.6);
        transition: all 0.3s ease;
    }

    .hamburger.open svg {
        opacity: 1;
        transform: scale(1);
    }

    nav a {
        color: #101010;
        font-size: 32px;
    }

    .close-icon {
        position: absolute;
        right: 20px;
        z-index: 1100;
        cursor: pointer;
        transition: opacity 0.3s ease, transform 0.3s ease;
    }

    .close-icon svg {
        width: 24px;
        height: 24px;
    }

    .talk-btn-desktop {
        display: none;
    }

    .talk-btn-mobile {
        display: block;
        width: 90%;
        height: 8%;
        font-size: 20px;
        position: relative;
        margin-bottom: 20px;
        margin-top: 100px;
    }

    .talk-btn-mobile:active {
        background: #000;
    }

    .mobile-logo {
        width: 140px;
        position: absolute;
        top: 20px;
        left: 20px;
    }

    nav a.router-link-exact-active {
        color: #F63E02;
    }
}
</style>